<section class="case-study-detail-hero">
  <div class="container">
    <div class="row">
      <div class="col-lg-12">
        <div class="hero-content text-center">
          <span class="hero-badge">Finance Case Study</span>
          <h1 class="hero-title">Fraud Detection System</h1>
          <p class="hero-description">Implemented real-time fraud detection using machine learning models, improving accuracy by 92%.</p>
        </div>
      </div>
    </div>
  </div>
</section>

<section class="case-study-overview ptb-100">
  <div class="container">
    <div class="row">
      <div class="col-lg-8">
        <div class="overview-content">
          <h2>Overview</h2>
          <p>SecureBank Ltd., one of India's leading financial institutions, was facing increasing challenges with fraudulent transactions. Traditional rule-based systems were generating too many false positives while missing sophisticated fraud patterns, leading to customer dissatisfaction and financial losses.</p>
          
          <h3>The Challenge</h3>
          <ul class="challenge-list">
            <li>Traditional fraud detection systems with 65% accuracy rate</li>
            <li>High number of false positives affecting customer experience</li>
            <li>Increasing sophistication of fraud techniques</li>
            <li>Need for real-time detection without impacting transaction speed</li>
          </ul>
          
          <h3>Our Solution</h3>
          <p>Insightful IT Services developed an advanced AI-powered fraud detection system using machine learning algorithms and real-time analytics. The solution included:</p>
          
          <div class="solution-features">
            <div class="feature-item">
              <i class="bx bx-chip"></i>
              <div class="feature-content">
                <h4>Machine Learning Models</h4>
                <p>Advanced neural networks trained on historical transaction data</p>
              </div>
            </div>
            
            <div class="feature-item">
              <i class="bx bx-data"></i>
              <div class="feature-content">
                <h4>Real-time Processing</h4>
                <p>Sub-millisecond processing for instant fraud detection</p>
              </div>
            </div>
            
            <div class="feature-item">
              <i class="bx bx-shield"></i>
              <div class="feature-content">
                <h4>Adaptive Learning</h4>
                <p>Continuous model improvement based on new fraud patterns</p>
              </div>
            </div>
          </div>
          
          <h3>Implementation Process</h3>
          <div class="timeline">
            <div class="timeline-item">
              <div class="timeline-date">Week 1-2</div>
              <div class="timeline-content">
                <h4>Data Assessment</h4>
                <p>Analysis of 2 years of transaction data and fraud patterns</p>
              </div>
            </div>
            
            <div class="timeline-item">
              <div class="timeline-date">Week 3-5</div>
              <div class="timeline-content">
                <h4>Model Development</h4>
                <p>Development and training of machine learning algorithms</p>
              </div>
            </div>
            
            <div class="timeline-item">
              <div class="timeline-date">Week 6-8</div>
              <div class="timeline-content">
                <h4>System Integration</h4>
                <p>Integration with existing banking infrastructure</p>
              </div>
            </div>
            
            <div class="timeline-item">
              <div class="timeline-date">Week 9-10</div>
              <div class="timeline-content">
                <h4>Testing & Deployment</h4>
                <p>Comprehensive testing and gradual rollout</p>
              </div>
            </div>
          </div>
        </div>
      </div>
      
      <div class="col-lg-4">
        <div class="client-info-card">
          <div class="client-header">
            <img src="assets/img/case-studies/finance.jpg" alt="SecureBank Ltd." class="client-logo">
            <h3>SecureBank Ltd.</h3>
            <p class="industry">Financial Services</p>
          </div>
          
          <div class="client-details">
            <div class="detail-item">
              <span class="label">Location:</span>
              <span class="value">Mumbai, India</span>
            </div>
            
            <div class="detail-item">
              <span class="label">Industry:</span>
              <span class="value">Banking & Finance</span>
            </div>
            
            <div class="detail-item">
              <span class="label">Employees:</span>
              <span class="value">8,500+</span>
            </div>
            
            <div class="detail-item">
              <span class="label">Project Duration:</span>
              <span class="value">2.5 Months</span>
            </div>
          </div>
          
          <div class="results-summary">
            <h4>Key Results</h4>
            <div class="result-item">
              <span class="result-value">92%</span>
              <span class="result-label">Detection Accuracy</span>
            </div>
            
            <div class="result-item">
              <span class="result-value">60%</span>
              <span class="result-label">Response Time</span>
            </div>
            
            <div class="result-item">
              <span class="result-value">75%</span>
              <span class="result-label">False Positives</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>

<section class="technology-section bg-light ptb-100">
  <div class="container">
    <div class="section-title text-center mb-5">
      <h2>Technology Stack</h2>
      <p>Advanced technologies that powered this successful implementation</p>
    </div>
    
    <div class="row">
      <div class="col-lg-4 col-md-6 mb-4">
        <div class="tech-card">
          <div class="tech-icon">
            <i class="bx bx-chip"></i>
          </div>
          <h3>Machine Learning</h3>
          <p>TensorFlow and PyTorch for developing fraud detection models</p>
        </div>
      </div>
      
      <div class="col-lg-4 col-md-6 mb-4">
        <div class="tech-card">
          <div class="tech-icon">
            <i class="bx bx-data"></i>
          </div>
          <h3>Real-time Analytics</h3>
          <p>Apache Kafka for streaming transaction data processing</p>
        </div>
      </div>
      
      <div class="col-lg-4 col-md-6 mb-4">
        <div class="tech-card">
          <div class="tech-icon">
            <i class="bx bx-cloud"></i>
          </div>
          <h3>Cloud Infrastructure</h3>
          <p>Scalable cloud environment with auto-scaling capabilities</p>
        </div>
      </div>
    </div>
  </div>
</section>

<section class="cta-section ptb-100">
  <div class="container">
    <div class="cta-content-wrapper text-center">
      <h2>Ready to Transform Your Business?</h2>
      <p>See how our solutions can help you achieve similar results</p>
      <div class="cta-actions">
        <a class="btn-cta-primary" routerLink="/contact">
          <i class="bx bx-phone"></i>
          <span>Get In Touch</span>
        </a>
        <a class="btn-cta-secondary" routerLink="/case-studies">
          <i class="bx bx-book"></i>
          <span>View All Case Studies</span>
        </a>
      </div>
    </div>
  </div>
</section>